export default Object.freeze({
  IPHONE_X: 375,
  IPHONE_8_PLUS: 414,
  IPHONE_8_PLUS_LANDSCAPE: 736,
  IPAD_PORTRAIT: 768, // Tablet portrait breakpoint
  IPAD_LANDSCAPE: 1024, // Tablet landscape breakpoint
  MD_VIEWPORT: 1523
})